// extracted by mini-css-extract-plugin
export default {"defaultWrapper":"OVEoI","timer":"GE_v1","textBeforeTimer":"MjI4G","textAfterTimer":"mVPrk","inlineWrapper":"Gg4N3","pulse":"B_2nW"};